module.exports = __webpack_public_path__ + "img/kozari_dori.9581511f.jpg";